import toError from './parsers/error';

import * as http from '../../utils/http';
import { keysToSnakeCase, keysToCamelCase } from '../../utils/object';


export default function (settings) {

  function _parseSuccessResponse({ data }) {
    data = keysToCamelCase(data || {});

    let { createdTs, updatedTs } = data;

    createdTs = new Date(createdTs * 1000);
    updatedTs = new Date(updatedTs * 1000);

    return {
      ...data,
      createdTs,
      updatedTs,
    };
  }


  function get() {
    return http.get(`${settings.apiUrl}/catalog/settings`)
      .then(_parseSuccessResponse)
      .catch(function () {
        return {};
      });
  }

  function update(trigger, data) {
    data = keysToSnakeCase(data);

    return http.post(`${settings.apiUrl}/catalog/settings`, { data })
      .then(_parseSuccessResponse)
      .catch(toError);
  }

  function reset() {
    return http.del(`${settings.apiUrl}/catalog/settings`)
      .then(_parseSuccessResponse)
      .catch(toError);
  }


  return {
    get,
    update,
    reset,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/settings.js